import React from "react";
import "../styles/Branches.css";

const branches = [
    {
        name: "Head Office",
        address: "446, Jagannath Shankar Seth Road, Chira Bazaar, Mumbai-400002",
        phone: "022-22017477 / 022-22085494",
        ifsc: "SVCB0013001",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: false,
        locker: false,
        map: "https://www.google.com/maps/place/The+Sahayadri+Sahakari+Bank+Ltd/@18.9485211,72.8249326,20z/data=!4m6!3m5!1s0x3be7ce18da8bf2b1:0x122b1e36c44af0b4!8m2!3d18.9485459!4d72.8254413!16s%2Fg%2F11clvn14hq?entry=ttu&g_ep=EgoyMDI2MDMwMS4xIKXMDSoASAFQAw%3D%3D"
    },
    {
        name: "Chira Bazaar Branch",
        address: "5/6 Sahyadri Bhavan, Vijay Wadi, Chira Bazaar, Mumbai-400002",
        phone: "022-22054671 / 022-22054672",
        ifsc: "SVCB0013002",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: false,
        locker: true,
        map: "https://maps.app.goo.gl/o5tnXfA9sBtqxBf29"
    },
    {
        name: "Vitthalwadi Branch",
        address: "Ground Floor Anand Properties , 384-M , Kalbadevi Road Dabholkarwadi , Kalbadevi Mumbai-400002",
        phone: "022-22425589",
        ifsc: "SVCB0013003",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: true,
        locker: true,
        map: "https://www.google.com/maps/place/Cloth+Markets+and+Shops+Board/@18.9560919,72.8289703,18.8z/data=!4m6!3m5!1s0x3be7ce3d1283f187:0x28cbeefce5db07c4!8m2!3d18.9562478!4d72.8295564!16s%2Fg%2F11c6pv062q?entry=tts"
    },
    {
        name: "Lalbaugh Branch",
        address: "Shop no -14 ,A wing ,Tejukaya Esperanza, Dr B.A Marg , lalbaug, Mumbai-400012",
        phone: "022-45817477 / 022-47127478",
        ifsc: "SVCB0013004",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: false,
        locker: false,
        map: "https://www.google.com/maps/place/The+Sahayadri+Sahakari+Bank+Limited+Mumbai+-+Lalbaug+Branch/@18.9891608,72.530583,11z/data=!4m7!3m6!1s0x3be7cef62753c873:0x3e9a0bc9536a4c2c!8m2!3d18.9891608!4d72.8354536!15sCh9UaGUgU2FoYXlhZHJpIFNhaGFrYXJpIEJhbmsgTHRkkgEEYmFua-ABAA!16s%2Fg%2F1ptwx6ngb?entry=tts"
    },
    {
        name: "Kandivali Branch",
        address: "Sahyadri Nagar, Charkop, Kandivali West, Mumbai-400067",
        phone: "022-28692529 / 022-28685099",
        ifsc: "SVCB0013005",
        workinghours:"Monday to Saturady (09:30 am - 4:30 pm)",
        atm: true,
        locker: true,
        map: "https://www.google.com/maps/place/The+Sahyadri+Sahakari+Bank+Limited/@19.21073,72.5239214,11z/data=!4m6!3m5!1s0x3be7b6c9c4ed57d9:0xbfd1648dbcc61dc4!8m2!3d19.21073!4d72.828792!16s%2Fg%2F1yg93rfry?entry=ttu&g_ep=EgoyMDI2MDMwMS4xIKXMDSoASAFQAw%3D%3D"
    },
    {
        name: "Satara Branch",
        address: "Seven Star Commercial Complex,Shop No- N4 & N5 ,Near Satara Bus Depot, Ravivar Peth, Satara-415001",
        phone: "02162-232105 / 02162-232106",
        ifsc: "SVCB0013006",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: true,
        locker: true,
        map: "https://www.google.com/maps/place/7+Star+Mall/@17.6919843,74.0031636,18.51z/data=!4m6!3m5!1s0x3bc239bfc4482cbf:0x5e9bc0d5e90fedd4!8m2!3d17.6918405!4d74.0041923!16s%2Fg%2F11hbkzn52_?entry=tts"
    },
    {
        name: "Kamothe Branch",
        address: "2/21 Suraj Park, Sector 36, Kamothe Navi Mumbai-410209",
        phone: "022-27438187 / 022-27431588",
        ifsc: "SVCB0013007",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: false,
        locker: true,
        map: "https://www.google.com/maps/place/The+Sahyadri+Sahakari+Bank/@19.0236994,73.0871785,17z/data=!3m1!4b1!4m6!3m5!1s0x3be7e9d70b7677eb:0x74bc5de965c63eb1!8m2!3d19.0236943!4d73.0897588!16s%2Fg%2F1pv0tnt7f?entry=tts"
    },
    {
        name: "Bhiwandi Branch",
        address: "Haridhara Shopping Complex, Anjur Phata, Bhiwandi-421302",
        phone: "02522-278833 / 02522-278882",
        ifsc: "SVCB0013008",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: true,
        locker: true,
        map: "https://www.google.com/maps/place/The+Sayadri+Sahakari+Bank+Bhiwandi/@19.2733882,73.0422636,20.68z/data=!4m6!3m5!1s0x3be7bdad62352259:0x196c84f2e5888f3e!8m2!3d19.2734625!4d73.0424554!16s%2Fg%2F11clvvr5_d?entry=tts"
    },
    {
        name: "Dombivli Branch",
        address: "White House Building MIDC, Sonarpada, Dombivli East-421203",
        phone: "0251-2439896",
        ifsc: "SVCB0013009",
        workinghours:"Monday to Saturady (10:30 am - 5:30 pm)",
        atm: false,
        locker: true,
        map: "https://www.google.com/maps/search/Shop+No+5A,+White+house+Building,+MIDC+Plot+No+156+%26+157,+Near+Sonarpada+Bus+Stop,+Opp+Annapurna+Restaurant,+Dombivali+East,+NH-MH-76+Kalyan+Shilphata+Road,+Thane-+421203/@19.2859846,72.9440341,8.75z?entry=ttu&g_ep=EgoyMDI2MDMwMS4xIKXMDSoASAFQAw%3D%3D"
    },
];

function Branches() {
    return (
        <div className="branches-wrapper">

            {/* HERO */}

            <section className="branches-hero">
                <div className="branches-hero-text">
                    <h1>Our Branch Network</h1>
                </div>
            </section>

            {/* CARDS */}

            <div className="branches-container">

                <div className="branches-grid">
                    {branches.map((b, i) => (
                        <div className="branch-card" key={i}>

                            <h3>{b.name}</h3>

                            <p><strong>Address:</strong> {b.address}</p>
                            <p><strong>Phone:</strong> {b.phone}</p>
                            <p><strong>IFSC:</strong> {b.ifsc}</p>
                            <p><strong>Working Hours:</strong> {b.workinghours}</p>

                            <div className="branch-status">
                                <span className={b.atm ? "yes" : "no"}>
                                    ATM: {b.atm ? "Available" : "Not Available"}
                                </span>

                                <span className={b.locker ? "yes" : "no"}>
                                    Locker: {b.locker ? "Available" : "Not Available"}
                                </span>
                            </div>

                            <a
                                href={b.map}
                                target="_blank"
                                rel="noreferrer"
                                className="direction-btn"
                            >
                                Get Direction
                            </a>

                        </div>
                    ))}
                </div>

            </div>

        </div>
    );
}

export default Branches;
